import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { downloadExcelOS, fetchOutstandingDealers } from '@/api/orders-dispatches';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery } from '@/utils/index';
import Inr from '@/components/Inr/index.vue';
import { getAgents } from '@/api/agents';
import { AdminModule } from '@/store/modules/admin';
import { searchDealers } from '@/api/dealers';
import { cleanListQuery, isAdmin, isSuperAdmin, isReadOnly } from '@/common';
import { BranchAgentService } from '@/services/branch-agent-service';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.tableKey = 0;
    this.total = 0;
    this.totalBalance = 0;
    this.list = [];
    this.listLoading = true;
    this.isAgent = false;
    this.agentList = [];
    this.dealerList = [];
    this.branchListLoading = false;
    this.branchList = [];
    this.dealerListLoading = false;
    this.dateRange = '';
    this.downloadLoading = false;
    this.totalGrandTotal = '';
    this.assignedBranches = [] || null;
    this.listQuery = {
      page: 1,
      limit: 10,
      dealerId: undefined,
      agentId: undefined,
      startDate: undefined,
      endDate: undefined,
      branchId: undefined,
      excludeBranches: false,
      fromDashboard: false,
      advance: true,
      applyBranchIdFilter: true
    };
  }
  onCheckboxChange(value) {
    this.listQuery.excludeBranches = value;
  }
  _isAdminRoles() {
    return isSuperAdmin() || isAdmin() || isReadOnly();
  }
  sortChange(data) {
    const {
      prop,
      order
    } = data;
    if (prop) {
      this.listQuery.sort = `${prop},` + (order === 'ascending' ? 'ASC' : 'DESC');
      this.handleFilter();
    }
  }
  async activated() {
    try {
      // check if logged in user is Agent/Admin
      if (AdminModule.userType === 'Agent') {
        this.isAgent = true;
        this.listQuery.agentId = AdminModule.agentId;
      }
      this.listQuery.excludeBranches = true;
      // Extract branchId from the URL
      const branchIdFromURL = this.$route.query.branchId;
      // If branchId exists in the URL, assign it
      if (branchIdFromURL) {
        this.listQuery.branchId = branchIdFromURL;
      }
      // Assign branchId using BranchAgentService
      // this.listQuery.branchId = await BranchAgentService.assignBranchId();
      this.assignedBranches = await BranchAgentService.assignBranchId();
      // Check if branchId is null and throw an error
      if (this.assignedBranches === null) {
        throw new Error('You are not assigned to a branch.');
      }
      // Fetch agents for the assigned branchId
      this.agentList = await BranchAgentService.fetchAgents(this.assignedBranches);
      // Fetch branches for non-super admin users
      this.branchList = await BranchAgentService.fetchBranches(this.assignedBranches);
      this.getList();
    } catch (err) {
      if (err instanceof Error) {
        this.$notify.error({
          title: 'Error',
          message: err.message
        });
      }
      this.listLoading = false;
    }
  }
  async getList() {
    try {
      this.listQuery = cleanListQuery(this.listQuery);
      if (this.dateRange) {
        this.listQuery.startDate = this.dateRange.start;
        this.listQuery.endDate = this.dateRange.end;
      }
      this.listLoading = true;
      const data = await fetchOutstandingDealers(this.listQuery);
      this.list = data.data;
      this.totalBalance = data.totalBalance;
      this.totalGrandTotal = data.grandTotal;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      // search only if length is greater than 1 if query is id else 2
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        this.dealerList = [];
        return;
      }
      const searchParams = {
        keyword: query,
        searchBy: isNumeric ? 'dealerId' : 'name',
        applyBranchIdFilter: true,
        fromDealer: true
      };
      if (this.listQuery.branchId !== undefined) {
        searchParams.branchId = this.listQuery.branchId;
      }
      if (this.listQuery.agentId !== undefined) {
        searchParams.agentId = this.listQuery.agentId;
      }
      this.dealerList = await searchDealers(searchParams);
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async handleFilter() {
    var _AdminModule$branchId;
    this.listQuery.page = 1;
    // handle branch and agent code
    // Fetch agents for a single branch
    if ((!isSuperAdmin() || !isAdmin()) && ((_AdminModule$branchId = AdminModule.branchIds) === null || _AdminModule$branchId === void 0 ? void 0 : _AdminModule$branchId.length) === 1) {
      this.listQuery.branchId = AdminModule.branchIds[0];
    }
    if (this.listQuery.branchId !== undefined && this.listQuery.branchId.length > 0) {
      // Fetch agents and branches for non-superadmin/admin users
      this.agentList = await BranchAgentService.fetchAgents(this.listQuery.branchId);
      await BranchAgentService.fetchBranches(this.listQuery.branchId);
      // Fetch the list after agents and branches are loaded
      this.getList();
    } else {
      // await this.handleClearBranch();
      this.getList();
    }
  }
  async handleExcelDownload() {
    this.downloadLoading = false;
    this.listQuery = cleanListQuery(this.listQuery);
    try {
      const query = this.listQuery;
      let startDate = '';
      let endDate = '';
      if (this.listQuery.startDate && this.listQuery.endDate) {
        startDate = this.listQuery.startDate;
        endDate = this.listQuery.endDate;
      }
      // let datas: any = await this.getListWithoutPagination();
      // let data = datas.data;
      const blob = await downloadExcelOS({
        query,
        startDate,
        endDate,
        applyBranchIdFilter: true,
        advance: true
      });
      // Create a blob URL for the Excel file
      const url = window.URL.createObjectURL(blob);
      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Advance.xlsx');
      document.body.appendChild(link);
      // Simulate click to trigger download
      link.click();
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading Excel:', error);
      this.$message.error('Error downloading Excel');
    } finally {
      // Reset loading state
      this.downloadLoading = false;
    }
  }
  async fetchAgents() {
    this.agentList = await getAgents(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: 'eq'
      }
    }));
  }
  getSummaries(param) {
    const {
      columns,
      data
    } = param;
    const sums = [];
    const totalGrandTotalRow = [];
    columns.forEach((column, index) => {
      // first column
      if (index === 0) {
        sums[index] = 'Total Page Sales: ';
        totalGrandTotalRow[index] = 'Grand Total: '; // Add label for the total grand total row
        return;
      }
      // Grand Total column
      if (index === 2) {
        // get all values
        const values = data.map(item => Number(item[column.property]));
        // loop over & null check
        if (!values.every(value => isNaN(value))) {
          // sum them using reduce
          sums[index] = values.reduce((prev, curr) => {
            // value conversion (do check with Sandesh if toFixed something else required for decimal precision)
            const value = Number(curr);
            // null check
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0); // initial value
          // Calculate total grand total
          totalGrandTotalRow[index] = parseFloat(this.totalGrandTotal).toFixed(2); // Store the totalGrandTotal value
        } // loop if ends
      } // index check ends
    }); // column loop ends
    // Return sums and total grand total row
    if (sums && sums.length) {
      sums[2] = sums[2].toFixed(2);
    }
    return [undefined, sums, totalGrandTotalRow]; // Return both the sums and total grand total row
  }
};
default_1 = __decorate([Component({
  name: 'AdvanceList',
  components: {
    Pagination,
    Inr
  }
})], default_1);
export default default_1;